import * as React from 'react';
import { AccessibleSeatingProps } from '../../components/cart/accessible-seating';

const AccessibleSeatingView: React.StatelessComponent<AccessibleSeatingProps> = props => {
    function onChange(event) {
        
        var value = event.target.checked;
        props.updateAccessibleSeatingRequest(value);

    }

    return (
        <div>
            <input type="checkbox" id="accessibleSeating" onChange={onChange} />
            <label htmlFor="accessibleSeating">{props.accessibleSeatingLabel}</label>
            
            <div className={`rich-text space-top-sm`} dangerouslySetInnerHTML={{ __html: props.accessibleSeatingText }}></div>
        </div>
    );
}

export default AccessibleSeatingView;